module.exports = __webpack_public_path__ + "img/gili2.0c8c7650.jpg";